/**
 * 获得广告相关逻辑
 * create by sevencai@20180823
 * contact sevencai@tencent.com
 */
import { getScript } from '@/api/util'

/**
 * 获得广告位 js 文件
 */
const getAdsApi = async () => {
  if (!window.MidasAds) {
    await getScript('//midas.gtimg.cn/h5pay/js/mod/midas-ads.js')
  }
  return window.MidasAds
}

/**
 * 通过广告名称获得广告
 * @param name
 */
export async function getAdsByName<T>(name: string): Promise<T> {
  const api = await getAdsApi()
  return api.get(name)
}

/**
 * 获得福利专区首页广告列表
 */
export async function getIndexAds() {
  const api = await getAdsApi()

  const swiperAds = api.get('fulizone_scroll_banner')
  const reserveGames = api.get('fulizone_recommend_tab')
  const topBanner = api.get('fulizhuanqu_banner1')
  const topBannerList = api.get('fulizhuanqu_list_banner')
  return {
    swiperAds,
    reserveGames,
    topBanner,
    topBannerList
  }
}
